module.exports = __webpack_public_path__ + "static/img/1-1Z524150203952.8556e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z524150203952.jpg
// module id = uwsv
// module chunks = 0